import * as React from "react";
const SvgPause = (props) => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill={props.color}
      d="M11.325 0v32H5.333V0h5.992zm14.58 0v32h-5.992V0h5.992z"
    />
  </svg>
);
export default SvgPause;
